__turbopack_context__.v({
  "icon": "icon-box11-module-scss-module__AopMWW__icon",
  "iconBox1": "icon-box11-module-scss-module__AopMWW__iconBox1",
  "info": "icon-box11-module-scss-module__AopMWW__info",
  "title": "icon-box11-module-scss-module__AopMWW__title",
  "title1": "icon-box11-module-scss-module__AopMWW__title1",
});
